import { connect } from 'react-redux';
import PresentationComponent from '../../../components/event/EventQueryExposureModal';
import { getRetentionExposureError, getRetentionSQL } from '../../../reducers/analyticsApp';
import { exposeRetentionQuery } from '../../../actions/retention/retention';

const mapStateToProps = (state) => ({
  sql: getRetentionSQL(state),
  error: getRetentionExposureError(state),
  showButton: true,
});

const mapDispatchToProps = (dispatch) => ({
  expose: () => dispatch(exposeRetentionQuery()),
});

const EventsQueryExposureModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(PresentationComponent);

export default EventsQueryExposureModal;
